import React from 'react';

export const Envelope = () => {
	return (
		<svg
			fill='none'
			version='1.1'
			viewBox='0 0 177 136'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g>
				<circle cx='88.494' cy='71' r='65' fill='#fff' />
			</g>
			<g filter='url(#filter0_d_9626_4381)'>
				<g clipPath='url(#clip0_9626_4381)'>
					<path
						d='m124.55 47.67v12.535l-25.706 16.777-10.35 6.7448-10.35-6.7448-27.827-18.156v-32.366c-0.0119-0.5603 0.0897-1.1172 0.2987-1.6373 0.209-0.52 0.521-0.9923 0.9173-1.3886s0.8687-0.7083 1.3887-0.9173 1.0769-0.3106 1.6373-0.2988h65.751c0.56-0.0118 1.117 0.0898 1.637 0.2988s0.992 0.521 1.389 0.9173c0.396 0.3963 0.708 0.8686 0.917 1.3886 0.209 0.5201 0.311 1.077 0.299 1.6373v21.21z'
						fill='#F1F2F2'
					/>
					<path
						d='m50.315 47.669v11.156l-10.605-6.9144s2.1209-4.242 10.605-4.242z'
						fill='#FED049'
					/>
					<path
						d='m136.43 52.462-11.877 7.7416v-12.535h4.242c1.594 7e-4 3.156 0.4507 4.507 1.2986 1.35 0.8478 2.435 2.059 3.128 3.4948z'
						fill='#FED049'
					/>
					<path
						d='m124.55 60.204 11.878-7.7416c0.561 1.1489 0.852 2.4116 0.848 3.6905v55.146c-1e-3 1.201-0.262 2.387-0.764 3.478l-37.414-37.414-0.2545-0.3817 25.706-16.777z'
						fill='#F6B445'
					/>
					<path
						d='m124.55 102.82 11.963 11.962c-0.667 1.491-1.75 2.756-3.12 3.644-1.37 0.889-2.968 1.361-4.601 1.362h-80.597c-1.6327-1e-3 -3.2304-0.473-4.6003-1.362-1.37-0.888-2.4536-2.153-3.1201-3.644l37.414-37.414 0.2545-0.3818 10.35 6.7447 10.35-6.7447 0.2545 0.3818 25.451 25.452z'
						fill='#FED049'
					/>
					<path
						d='m50.315 58.826 27.827 18.156-0.2545 0.3818-25.452 25.452-11.962 11.962c-0.502-1.091-0.7625-2.277-0.7635-3.478v-59.388l10.605 6.9144z'
						fill='#F6B445'
					/>
					<path
						d='m73.648 45.549c3.5142 0 6.363-2.8488 6.363-6.363 0-3.5141-2.8488-6.3629-6.363-6.3629s-6.3629 2.8488-6.3629 6.3629c0 3.5142 2.8487 6.363 6.3629 6.363z'
						fill='#A4B0C0'
					/>
					<g fill='#474C54'>
						<path d='m128.79 45.548h-2.121v-19.089c0.025-0.8423-0.123-1.6807-0.434-2.4638-0.311-0.7832-0.779-1.4945-1.375-2.0903-0.596-0.5959-1.307-1.0637-2.09-1.3747-0.783-0.3111-1.622-0.4588-2.464-0.4342h-65.75c-0.8423-0.0246-1.6807 0.1231-2.4638 0.4342-0.7832 0.311-1.4945 0.7788-2.0903 1.3747-0.5958 0.5958-1.0636 1.3071-1.3747 2.0903-0.311 0.7831-0.4588 1.6215-0.4341 2.4638v21.21c0 0.5625 0.2234 1.102 0.6212 1.4998 0.3977 0.3978 0.9372 0.6212 1.4997 0.6212 0.5626 0 1.102-0.2234 1.4998-0.6212s0.6212-0.9373 0.6212-1.4998v-21.21c-0.028-0.2855 0.0076-0.5736 0.1043-0.8437s0.252-0.5153 0.4549-0.7182c0.2028-0.2028 0.4481-0.3581 0.7181-0.4548 0.2701-0.0967 0.5582-0.1323 0.8437-0.1043h65.75c0.286-0.028 0.574 0.0076 0.844 0.1043s0.515 0.252 0.718 0.4548c0.203 0.2029 0.358 0.4481 0.455 0.7182s0.132 0.5582 0.104 0.8437v21.21c0 0.5625 0.224 1.102 0.621 1.4998 0.398 0.3978 0.938 0.6212 1.5 0.6212h4.242c0.882-9e-4 1.755 0.1823 2.562 0.5381 0.807 0.3557 1.531 0.8761 2.126 1.5277l-44.986 29.338-47.625-31.058c-0.3199-0.2085-0.6902-0.3267-1.0718-0.3423-0.3816-0.0155-0.7603 0.0723-1.0961 0.2541s-0.6163 0.4509-0.8119 0.7789-0.299 0.7027-0.2993 1.0846v59.388c0.0034 2.812 1.1218 5.507 3.1099 7.495s4.6835 3.106 7.4951 3.11h80.597c2.812-4e-3 5.507-1.122 7.495-3.11s3.107-4.683 3.11-7.495v-55.146c-3e-3 -2.8116-1.122-5.507-3.11-7.4951s-4.683-3.1065-7.495-3.1099zm6.363 65.751c0 1.688-0.67 3.306-1.864 4.499-1.193 1.194-2.811 1.864-4.499 1.864h-80.597c-1.6876 0-3.306-0.67-4.4993-1.864-1.1933-1.193-1.8637-2.811-1.8637-4.499v-55.472l33.043 21.549-23.937 23.939c-0.2026 0.196-0.3642 0.43-0.4753 0.689-0.1112 0.259-0.1697 0.537-0.1721 0.819-0.0025 0.281 0.0512 0.561 0.1578 0.821 0.1067 0.261 0.2642 0.498 0.4633 0.697 0.1992 0.199 0.436 0.356 0.6966 0.463 0.2607 0.107 0.54 0.16 0.8216 0.158s0.5599-0.061 0.8187-0.172 0.4928-0.273 0.6885-0.475l24.569-24.57 8.8297 5.7563c0.3445 0.2245 0.7468 0.3441 1.1581 0.3441 0.4112 0 0.8135-0.1196 1.158-0.3441l8.8297-5.7563 24.57 24.57c0.4 0.386 0.935 0.6 1.492 0.595 0.556-5e-3 1.088-0.228 1.481-0.621 0.393-0.394 0.616-0.926 0.621-1.482s-0.209-1.092-0.595-1.492l-23.938-23.939 33.043-21.543v0.3203 55.146z' />
						<path d='m82.13 39.186c0-1.6779-0.4976-3.3182-1.4298-4.7134s-2.2573-2.4826-3.8075-3.1247-3.2561-0.8101-4.9018-0.4828c-1.6457 0.3274-3.1574 1.1354-4.3439 2.3219s-1.9945 2.6982-2.3219 4.3439c-0.3273 1.6457-0.1593 3.3516 0.4828 4.9018s1.7296 2.8753 3.1247 3.8075c1.3952 0.9322 3.0355 1.4298 4.7135 1.4298 2.25 0 4.408-0.8939 5.999-2.4849 1.591-1.5911 2.4849-3.749 2.4849-5.9991zm-12.726 0c0-0.8389 0.2488-1.6591 0.7149-2.3567s1.1286-1.2413 1.9037-1.5623c0.7751-0.3211 1.6281-0.4051 2.4509-0.2414 0.8229 0.1637 1.5787 0.5677 2.172 1.1609 0.5932 0.5933 0.9972 1.3491 1.1609 2.172 0.1637 0.8228 0.0797 1.6758-0.2414 2.4509-0.321 0.7751-0.8647 1.4376-1.5623 1.9037s-1.5178 0.7149-2.3567 0.7149c-1.1251 0-2.204-0.4469-2.9996-1.2424-0.7955-0.7956-1.2424-1.8745-1.2424-2.9996z' />
						<path d='m90.614 34.944h19.089c0.563 0 1.102-0.2235 1.5-0.6213 0.398-0.3977 0.621-0.9372 0.621-1.4997s-0.223-1.102-0.621-1.4998c-0.398-0.3977-0.937-0.6212-1.5-0.6212h-19.089c-0.5625 0-1.102 0.2235-1.4997 0.6212-0.3978 0.3978-0.6212 0.9373-0.6212 1.4998s0.2234 1.102 0.6212 1.4997c0.3977 0.3978 0.9372 0.6213 1.4997 0.6213z' />
						<path d='m90.614 47.669h19.089c0.563 0 1.102-0.2234 1.5-0.6212s0.621-0.9373 0.621-1.4998-0.223-1.102-0.621-1.4997c-0.398-0.3978-0.937-0.6213-1.5-0.6213h-19.089c-0.5625 0-1.102 0.2235-1.4997 0.6213-0.3978 0.3977-0.6212 0.9372-0.6212 1.4997s0.2234 1.102 0.6212 1.4998c0.3977 0.3978 0.9372 0.6212 1.4997 0.6212z' />
						<path d='m90.614 60.395h10.605c0.563 0 1.102-0.2235 1.5-0.6212 0.398-0.3978 0.621-0.9373 0.621-1.4998s-0.223-1.102-0.621-1.4998c-0.398-0.3977-0.937-0.6212-1.5-0.6212h-10.605c-0.5625 0-1.102 0.2235-1.4997 0.6212-0.3978 0.3978-0.6212 0.9373-0.6212 1.4998s0.2234 1.102 0.6212 1.4998c0.3977 0.3977 0.9372 0.6212 1.4997 0.6212z' />
					</g>
				</g>
			</g>
			<g fill='#474C54'>
				<rect y='67.867' width='18.795' height='6.2651' rx='3.1325' />
				<rect
					x='158.19'
					y='67.867'
					width='18.795'
					height='6.2651'
					rx='3.1325'
				/>
				<rect
					transform='rotate(-15 149.58 32.792)'
					x='149.58'
					y='32.792'
					width='18.795'
					height='6.2651'
					rx='3.1325'
					opacity='.8'
				/>
				<rect
					transform='rotate(-15 7.0488 108.59)'
					x='7.0488'
					y='108.59'
					width='18.795'
					height='6.2651'
					rx='3.1325'
					opacity='.8'
				/>
				<rect
					transform='rotate(15 151.2 103.89)'
					x='151.2'
					y='103.89'
					width='18.795'
					height='6.2651'
					rx='3.1325'
					opacity='.8'
				/>
				<rect
					transform='rotate(15 8.6699 27.927)'
					x='8.6699'
					y='27.927'
					width='18.795'
					height='6.2651'
					rx='3.1325'
					opacity='.8'
				/>
			</g>
			<defs>
				<filter
					id='filter0_d_9626_4381'
					x='37.59'
					y='20.097'
					width='101.81'
					height='104.94'
					colorInterpolationFilters='sRGB'
					filterUnits='userSpaceOnUse'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						result='hardAlpha'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
					/>
					<feOffset dy='3.13253' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0' />
					<feBlend
						in2='BackgroundImageFix'
						result='effect1_dropShadow_9626_4381'
					/>
					<feBlend
						in='SourceGraphic'
						in2='effect1_dropShadow_9626_4381'
						result='shape'
					/>
				</filter>
				<clipPath id='clip0_9626_4381'>
					<rect
						x='37.59'
						y='20.097'
						width='101.81'
						height='101.81'
						rx='10.964'
						fill='#fff'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
